<!-- -------------------------------------------------------------------------- -->
<!--  ANCHOR PANTALLA DE ACCESO                                                 -->
<!--  `main` es el unico landmark y envuelve TODO, interruptor de tema          -->
<!--  incluido: fuera de el seria contenido huerfano.                           -->
<!-- -------------------------------------------------------------------------- -->

<main class="acceso">

  <div class="acceso-caja">

    <section class="z-card acceso-tarjeta z-rise" aria-labelledby="acceso-titulo">
      <div class="z-card-body">

        <!-- ------------------------------ CABECERA ------------------------- -->

        <header class="acceso-cabecera">
          <img class="acceso-logo" src="assets/images/logo-zorro.png"
               alt="Zorro Abarrotero" width="232" height="128" />

          <h1 class="acceso-titulo" id="acceso-titulo">Acceso</h1>
          <p class="acceso-bajada">Entra con tu cuenta para ver el tablero de Zorro Abarrotero.</p>
        </header>

        <!-- ------------------------------ AVISO ---------------------------- -->
        <!-- Siempre en el DOM, con o sin mensaje dentro, y SIN `role="alert"`:
             al fallar se mueve el foco a este contenedor, que contiene el
             mensaje, y el lector lo anuncia al enfocarlo. Region viva y salto
             de foco a la vez se pisan — el foco corta el anuncio. -->

        <div class="acceso-aviso" #aviso tabindex="-1">
          @if (errorAcceso()) {
            <p class="z-alert" id="acceso-error">
              <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
              <span>{{ errorAcceso() }}</span>
            </p>
          }
        </div>

        <!-- ---------------------------- FORMULARIO ------------------------- -->

        <form class="acceso-form" novalidate (ngSubmit)="entrar()"
              [attr.aria-busy]="enviando() ? 'true' : null">

          <div class="acceso-campo">
            <label class="z-form-label" for="acceso-correo">Correo electrónico</label>

            <input id="acceso-correo" #campoCorreo
                   class="z-field"
                   type="email" name="correo" required
                   [class.is-error]="!!errorCorreo() || !!errorAcceso()"
                   [(ngModel)]="correo"
                   (ngModelChange)="limpiarCorreo()"
                   placeholder="nombre@empresa.com"
                   autocomplete="username" inputmode="email"
                   autocapitalize="none" spellcheck="false" enterkeyhint="next"
                   [attr.aria-invalid]="(errorCorreo() || errorAcceso()) ? 'true' : null"
                   [attr.aria-describedby]="describeCorreo()" />

            @if (errorCorreo()) {
              <p class="z-field-msg" id="acceso-correo-error">
                <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
                <span>{{ errorCorreo() }}</span>
              </p>
            }
          </div>

          <div class="acceso-campo">
            <label class="z-form-label" for="acceso-contrasena">Contraseña</label>

            <div class="acceso-campo-caja">
              <input id="acceso-contrasena" #campoContrasena
                     class="z-field acceso-campo-input"
                     [type]="verContrasena() ? 'text' : 'password'"
                     name="contrasena" required
                     [class.is-error]="!!errorContrasena() || !!errorAcceso()"
                     [(ngModel)]="contrasena"
                     (ngModelChange)="limpiarContrasena()"
                     (keydown)="revisarMayusculas($event)"
                     (keyup)="revisarMayusculas($event)"
                     placeholder="Tu contraseña"
                     autocomplete="current-password" enterkeyhint="go"
                     [attr.aria-invalid]="(errorContrasena() || errorAcceso()) ? 'true' : null"
                     [attr.aria-describedby]="describeContrasena()" />

              <!-- Etiqueta que cambia con el estado y nada de `aria-pressed`:
                   juntos se contradicen («Ocultar contraseña, pulsado»).
                   `type="button"` o Enter enviaria el formulario. -->
              <button class="z-icon-btn acceso-ojo" type="button"
                      (click)="alternarContrasena()"
                      [attr.aria-label]="verContrasena() ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <i class="bi" aria-hidden="true"
                   [class.bi-eye-fill]="!verContrasena()"
                   [class.bi-eye-slash-fill]="verContrasena()"></i>
              </button>
            </div>

            @if (errorContrasena()) {
              <p class="z-field-msg" id="acceso-contrasena-error">
                <i class="bi bi-exclamation-circle-fill" aria-hidden="true"></i>
                <span>{{ errorContrasena() }}</span>
              </p>
            }

            @if (mayusculas()) {
              <p class="z-field-msg acceso-mayusculas" id="acceso-mayusculas">
                <i class="bi bi-capslock-fill" aria-hidden="true"></i>
                <span>Bloq Mayús está activado.</span>
              </p>
            }
          </div>

          <!-- Toda la fila es zona de toque, no los 18px de la casilla. -->
          <label class="z-check-row" for="acceso-recordar">
            <input id="acceso-recordar" type="checkbox" name="recordar" [(ngModel)]="recordar" />
            <span>Mantener la sesión abierta en este equipo</span>
          </label>

          <!-- `aria-disabled` y nunca `disabled`: deshabilitar el boton que
               acaba de recibir el clic manda el foco al <body>, y `.z-btn:disabled`
               lo pinta al 50% justo cuando «Entrando…» es la unica realimentacion
               que hay. El doble envio lo corta la guarda del metodo. -->
          <button class="z-btn z-btn--teal w-100" type="submit"
                  [attr.aria-disabled]="enviando() ? 'true' : null">
            @if (enviando()) {
              <i class="bi bi-arrow-repeat acceso-girando" aria-hidden="true"></i>
              <span>Entrando…</span>
            } @else {
              <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>
              <span>Entrar</span>
            }
          </button>
        </form>

      </div>
    </section>

    <!-- Fuera de la tarjeta a propósito: dentro está el logo de quien son los
         datos, aquí abajo la firma de quien hizo el tablero. Es un `div` y no un
         `footer`: hay lectores que exponen `footer` como `contentinfo` aunque
         cuelgue de `main`, y este archivo se sostiene sobre un único landmark. -->

    <div class="acceso-pie z-vendor z-rise z-rise-2">
      <img class="z-vendor-logo" src="assets/images/logo-cleversec.png"
           alt="Cleversec" width="408" height="160" />
      <p class="acceso-copy z-text-muted">©2026</p>
    </div>

  </div>

  <!-- Ultimo en el DOM a proposito: asi el primer tabulador cae en el campo de
       correo y no en un control decorativo. Su sitio lo pone `position: absolute`.
       Fuera de la tarjeta, asi que su desenfoque es de primer nivel y es legal. -->
  <button class="z-theme-toggle acceso-tema" type="button" (click)="themeService.toggle()"
          [attr.aria-label]="themeService.theme() === 'dark' ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'">
    <i class="bi" aria-hidden="true"
       [class.bi-sun-fill]="themeService.theme() === 'dark'"
       [class.bi-moon-stars-fill]="themeService.theme() === 'light'"></i>
  </button>
</main>
